export default "__VITE_ASSET__CSUs9hxv__"